import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/6f9a979f-a54f-42f3-851d-07f5ed5c7269";
export const REGISTER_URL = "https://a.ntrk2.com/4a12005f-8c66-4ede-901b-7dfee3af2c3f";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://pepop.loadprkw2a.com/download?openExternalBrowser=1&id=xilecandyro94c2";

export * from "./codes";
export * from "./context";
